//! @/script/cart.js

// Cart add remove functions
var cart = {
  add: function (product_id, quantity, button) {
    $.post({
      url: "index.php?route=checkout/cart/add",
      data:
        "product_id=" +
        product_id +
        "&quantity=" +
        (typeof quantity != "undefined" ? quantity : 1),
      beforeSend: function () {
        buttonLoad(button);
      },
      complete: function () {
        buttonReset(button);
      },
      success: function (json) {
        $(".alert-dismissible, .text-danger").remove();

        if (json["success"]) {
          cart.info();
        }

        if (json["message"]) {
          $("#modal").modal("show");

          $("#modal .modal-body").empty();
          $("#modal .modal-body").append(
            $("<h3/>", {
              html: json["message"],
            })
          );
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },

  remove: function (key, button) {
    $.post({
      url: "index.php?route=checkout/cart/remove",
      data: "key=" + key,
      beforeSend: function () {
        buttonLoad(button);
      },
      complete: function () {
        buttonReset(button);
      },
      success: function (json) {
        // $('.alert-dismissible, .text-danger').remove();

        if (json["success"]) {
          $("#input-quantity-" + key)
            .closest("tr")
            .remove();
          $(".checkout__total").html(json["harsika_total"]);

          $("#text-minimum").toggle(!json["is_minimum"]);
          $("#button-cart").toggle(json["is_minimum"]);

          cart.info();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },

  update: function (key, quantity) {
    $.ajax({
      url: "index.php?route=checkout/cart/edit",
      type: "post",
      data:
        "quantity[" +
        key +
        "]=" +
        (typeof quantity != "undefined" ? quantity : 1),
      dataType: "json",
      beforeSend: function () {
        var $input = $("#input-quantity-" + key);
        $input.prop("disabled", true);
        $input
          .parent()
          .find("button")
          .each(function () {
            buttonLoad(this);
          });
      },
      complete: function () {
        var $input = $("#input-quantity-" + key);
        $input.prop("disabled", false);
        $input
          .parent()
          .find("button")
          .each(function () {
            buttonReset(this);
          });
      },
      success: function (json) {
        if (json["success"]) {
          $("#input-quantity-" + key).val(json[key]["quantity"]);
          $("#total-" + key).html(json[key]["total"]);
          $(".checkout__total").html(json["harsika_total"]);

          $("#text-minimum").toggle(!json["is_minimum"]);
          $("#button-cart").toggle(json["is_minimum"]);

          cart.info();

          // if (json['value_total'] < json['value_minimum']) {
          // $('#checkout-cart .form-fg button')
          // .tooltip('show')
          // .prop('disabled', true);
          // } else {
          // $('#checkout-cart .form-fg button')
          // .tooltip('hide')
          // .prop('disabled', false);
          // }
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(
          thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText
        );
      },
    });
  },

  info: function () {
    $("#cart").load("index.php?route=common/cart/info #cart > *");
  },
};

function qPlus() {
  var input = $("#input-quantity");

  var max = Number($(input).data("quantity"));
  var q = Number($(input).val()) + 1;

  if (max > 0 && q > max) q = max;

  $(input).val(q);
}

function qMinus() {
  var input = $("#input-quantity");
  var min = Number($(input).data("minimum"));
  var q = Number($(input).val()) - 1;

  if (min < 1) min = 1;
  if (q < min) q = min;

  $(input).val(q);
}

function qChange() {
  var input = $("#input-quantity");
  var min = Number($(input).data("minimum"));
  var max = Number($(input).data("quantity"));
  var q = Number($(input).val());

  if (min < 1) min = 1;
  if (q < min) q = min;
  if (max > 0 && q > max) q = max;

  $(input).val(q);
}

function cartMinus(cart_id) {
  var quantity = Number($("#input-quantity-" + cart_id).val()) - 1;
  cartUpdate(cart_id, quantity);
}

function cartPlus(cart_id) {
  var quantity = Number($("#input-quantity-" + cart_id).val()) + 1;
  cartUpdate(cart_id, quantity);
}

function cartUpdate(cart_id, quantity) {
  cart.update(cart_id, quantity);
}
